import React from 'react';
import {observer} from 'mobx-react';

import ContentView from '../../components/ui-controls/layout/ContentView';
import FlatListMenu from '../../components/ui-controls/MenuFlatList';
import {Department} from '../../models/middleware';

type RangeSubDepartmentsScreenProps = {
  department: Department;
  subDepartments: Department[];
  onSubDepartmentPress: (subDepartment: Department) => void;
};

const RangeSubDepartmentsScreen = observer(
  ({subDepartments, onSubDepartmentPress}: RangeSubDepartmentsScreenProps) => {
    return (
      <ContentView testID="shop-subdepartment-screen">
        <FlatListMenu
          data={subDepartments}
          onPressItem={onSubDepartmentPress}
        />
      </ContentView>
    );
  },
);

export default RangeSubDepartmentsScreen;
